<h1>Rewards/Snacks</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a mat-tab-link *ngFor="let tab of tabs" (click)="gotoTab(tab)" [active]="tab.link === activeTab.link">
    {{tab.title}}
  </a>
</nav>
<app-superadmin-rewards-list *ngIf="activeTab.id === 'rewards'"></app-superadmin-rewards-list>
<app-superadmin-rewards-rebates *ngIf="activeTab.id === 'rebates'"></app-superadmin-rewards-rebates>
<app-superadmin-rewards-brands *ngIf="activeTab.id === 'brands'"></app-superadmin-rewards-brands>
<app-superadmin-rewards-campaigns *ngIf="activeTab.id === 'campaigns'"></app-superadmin-rewards-campaigns>
<app-superadmin-rewards-claimed *ngIf="activeTab.id === 'claimed'"></app-superadmin-rewards-claimed>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
